import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import FundsTxnHistoryTable from "./table/fundTxnHistoryTable";

const FundsTxnHistoryPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="fundstxnhistory_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Funds Transfer History"
      table={<FundsTxnHistoryTable />}
    />
  );
};

export default FundsTxnHistoryPage;
